import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class IncreaseIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8"><path fillRule="evenodd" d="M.502 8a.502.502 0 0 1-.422-.773L4.578.23a.502.502 0 0 1 .844 0L9.92 7.227A.502.502 0 0 1 9.498 8H.502z"/></svg>
        )
    }
}

export default withCssClassName(IncreaseIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/increase-icon.js